export default __webpack_public_path__ + "static/media/pencil.d1b628a4.svg";